<template>
        <v-dialog v-model="dialog" width="500">
            <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon>
                    <v-icon>mdi-pencil</v-icon>
                </v-btn>
            </template>

            <v-card>
                <v-card-title>
                    Alter Gold
                </v-card-title>

                <v-card-text>
                    <v-text-field
                        type="number"
                        v-model="form.amount"
                        label="Amount"
                        @keydown.enter="alterGold"
                        hint="Negative value for subtraction"
                        />
                </v-card-text>

                <v-divider/>

                <v-card-actions>
                    <v-spacer/>
                    <v-btn color="secondary" text @click="dialog = false">
                        Cancel
                    </v-btn>
                    <v-btn color="primary" text @click="alterGold">
                        Submit
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
</template>

<script>
  import CharacterService from "../../services/CharacterService";

  export default {
    props: ['character'],

    data: () => ({
      dialog: false,
      form: {
        amount: null
      }
    }),

    methods: {
      alterGold() {
        CharacterService.alterGold(this.character.id, {
          amount: this.form.amount
        })
          .then(() => {
            this.form.amount = 0;
            this.$emit("goldAltered");
            this.dialog = false;
          })
          .catch(err => {
            console.log(err);
          });
      }
    }
  };
</script>